
<div class="flex flex-col gap-6 my-6">
  <label *ngFor="let option of durationOptions" [class]="(currentActiveDuration !== option.months ? 'hover:scale-max active:scale-min transition-all ' : '')"
    class="border rounded-full p-4 cursor-pointer transition-all duration-200 relative"
    [class.border-orange]="selectedDuration === option.months" 
    [class.border-green]="currentActiveDuration === option.months" 
    [class.border-2]="selectedDuration === option.months"
    [class.ring-orange]="selectedDuration === option.months">
    
    <!-- Indicador de plan activo -->
    <div *ngIf="currentActiveDuration === option.months" 
      class="absolute -top-3 right-10 bg-green text-white text-xs px-2 py-1 rounded-full font-medium flex items-center gap-1">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3 h-3">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span transloco="profile-vn.current"></span>
    </div>

    <div class="flex items-center {{ currentActiveDuration === option.months ? 'opacity-25 cursor-not-allowed' : '' }}">
      <div class="flex flex-1 items-center gap-2">
        <div class="font-medium text-sm">
          {{ 'profile-vn.months-label' | transloco: { months: option.months, suffix: (option.months > 1 ? ('profile-vn.months' | transloco) : ('profile-vn.month' | transloco)) } }}
        </div>
        <div class="{{option.discount ? 'text-orange': 'text-gray-400'}} font-bold text-sm ">
          ${{ option.price | number:'1.2-2' }}/<span transloco="profile-vn.month"></span>
        </div>
        <div *ngIf="option.discount" class="text-xs font-medium bg-orange text-white p-1 px-2 rounded-full">
          {{ option.discount }} 
          <span transloco="profile-vn.off"></span>
        </div>
      </div>

      <label class="flex items-center gap-2 text-sm cursor-pointer">
        <input [disabled]="currentActiveDuration === option.months" type="radio" name="duration" [checked]="selectedDuration === option.months"
          (change)="selectDuration(option)" class="text-orange focus:ring-orange hidden peer">

        <span
          class="h-5 w-5 flex justify-center items-center border rounded-full peer-checked:bg-orange peer-checked:border-orange">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="white"
            class="w-3 h-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </span>
      </label>
    </div>
  </label>
</div>